export const COMPONENT_NAME = 'BannerSupergraphic';